export default {
    items: [
        {
            name: 'Home',
            url: '/home',
            icon: 'icon icon-home'
        },
        {
            name: 'Entreprise',
            url: '/entreprise',
            icon: 'icon icon-briefcase'
        },
        {
            name: 'Opérations',
            url: '/operations',
            icon: 'icon icon-car-hatchback'
        },
        {
            name: 'Analytics',
            url: '/analytics',
            icon: 'icon icon-chart-bar'
        }
    ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js